// extracted by mini-css-extract-plugin
export default {"modalTop":"EditFiles_modalTop__hRRJW","title":"EditFiles_title__3EViD","buttonsContainer":"EditFiles_buttonsContainer__8WwJ7","dropDownItem":"EditFiles_dropDownItem__35DYz"};